<template>
  <form @submit.prevent="add">
    <modal-card title="Add Content">
      <b-field label="Path">
        <b-input v-model="form.path" placeholder="000/1"></b-input>
      </b-field>

      <div slot="foot">
        <button class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Add Content
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
export default {
  props: {
    added: {
      type: Function,
      default: () => () => {}
    }
  },

  data() {
    return {
      form: new window.Form({
        path: ""
      })
    };
  },

  methods: {
    add() {
      this.form.post("/admin/api/magazine/contents").then(this.whenAdded);
    },

    whenAdded(response) {
      this.$emit("added");

      this.$buefy.toast.open(`Content ${response.data.data.path} is added!`);

      this.$parent.close();
    }
  }
};
</script>
